import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=cca1379c&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=cca1379c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca1379c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cca1379c')) {
      api.createRecord('cca1379c', component.options)
    } else {
      api.reload('cca1379c', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=cca1379c&scoped=true&", function () {
      api.rerender('cca1379c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OtNfxgsEp0LL/JS/teamMember.vue"
export default component.exports